import PretenderServer from 'pretender';

export function initializeStaticAssets(pretender: PretenderServer): void {
  pretender.get('./assets/i18n/en.json', pretender.passthrough);
  pretender.get('assets/images/logo.svg', pretender.passthrough);
}
